import { Gap, GapActivityType } from "./types";

export const GAP_HISTORY_STORAGE_KEY = "gap-history-saved-state";

export function isGapStatementActivity(
  activity: GapActivityType,
  includesEducation: boolean
): boolean {
  return (
    activity === "OTHER" || (activity === "STUDYING" && !includesEducation)
  );
}

export function stringifyGaps(gaps: Gap[]): string {
  return JSON.stringify(gaps.map((gap) => [gap.start_date, gap.end_date]));
}
